// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"4c901468","611":"a28ba033"}[chunkId] + ".chunk.js";
};